<template>
	<div data-e2e="cms-router"></div>
</template>

<script>
export default {
	asyncData({
		store, route, host, env, staticPublicPath, res,
	}) {
		return new Promise((resolve) => {
			store.cms.getPageAndMetaData({
				route, host, env, staticPublicPath, res,
			})
				.then(() => {
					store.flow.getFlowInfoForAsset({ route, host })
						.then(() => {
							store.flow.setMetadata();
							resolve();
						});
				});
		});
	},
};
</script>
